define('topNavigation',['jquery'],
	function ($) {
		var topPosition = 0,
			topMenu = $('#main-navigation'),
			visible = true,
			hidden = false,
			detached = false,
			$window = $(window);
		$window.scroll(function () {

			if ($window.width()>1024) {
				var $this = $(this),
				newPosition = $this.scrollTop();

				if (newPosition === 0 && !visible) {
					visible = true;
					hidden = false;
					detached = false;
					topMenu.removeClass('hidden').removeClass('detached').addClass('visible');

				}
				else if (newPosition === 0 && detached) {
					detached = false;
					topMenu.removeClass('hidden').removeClass('detached').addClass('visible');
				}
				else if (newPosition > 0 && newPosition > topPosition && !hidden) {
					hidden = true;
					visible = false;
					topMenu.removeClass('visible').addClass('hidden');
					if (newPosition > 1 && !detached) {
						detached = true;
						topMenu.addClass('detached');
					}
				}
				else if (newPosition < topPosition) {
					hidden = false;
					visible = true;
					topMenu.removeClass('hidden').addClass('visible');
				}
				topPosition = newPosition;

			}
		});

		// Show/hide overlay when hovering menu
		var bodyOverlay = $(".body-overlay"),
            menuOverlay = $(".menu-overlay"),
            navigationContainer = $("header .navigation-container"),
		    megamenus = $(".megamenu"),
		    megamenuWithMostChildren = $(),
            navigationItems = $();

		var highestChildCount = 0;

		// Iterate through megamenus, and determine which ones have content, and which is the largest
        // The ones with content has their parent li added to navigationItems, as we only need to trigger hover effects on these
		megamenus.each(function() {
            var curChildCount = $(this).children().length;

            if (curChildCount === 0) {
                return;
            } else {
                // If our navigationItems already has elements, we add new to them. Otherwise we set it to this element
                if (navigationItems.length) {
                    navigationItems = navigationItems.add($(this).closest(".main-navigation > ul > li"));
                } else {
                    navigationItems = $(this).closest(".main-navigation > ul > li");
                }
            }

            // If child count is larger, set highestChildCount to curChildCount and the megamenuWithMostChildren to this element
            if (curChildCount > highestChildCount) {
                highestChildCount = curChildCount;
                megamenuWithMostChildren = $(this);
            }
        });

		// If there are no children of megamenu, the highest child count will still be 0, and we can return, since there is no megamenu to show
		if (highestChildCount === 0) {
		    return;
        }

		// Now that we know the megamenu who has most children, we can target its li's
        // We can also figure out which li's should be subNavigationItems, based on navigationItems
		var megamenuItems = megamenuWithMostChildren.children("li"),
            itemsPerColumn = Math.ceil(highestChildCount / 3),
		    subNavigationItems = navigationItems.find("li");

        // Evenly divide items in 3, and wrap megamenu around them
		for(var i=0, len = highestChildCount; i < len; i+=itemsPerColumn){
			megamenuItems.slice(i, i+itemsPerColumn).wrapAll('<div class="megamenu-childrens"/>');
		}
		// Stop events from bubbling
		subNavigationItems.on("click touchstart", function(event) {
            event.stopPropagation();
        });
		
		navigationItems.on("mouseover", function() {
			var $this = $(this);
			showMenu($this);
		}).on("mouseleave", function() {
            var $this = $(this);
            hideMenu($this);
		}).on("touchstart", function() {
            var $this = $(this);
            if ($this.hasClass("arrow")) {
                hideMenu($this);
            } else {
                showMenu($this);
            }
        }).on("click", function(event) {
		    event.preventDefault();
        });

		menuOverlay.add(bodyOverlay).on("touchend", function() {
            var activeElement = navigationItems.filter(".arrow");
            if (activeElement.length) {
                hideMenu(activeElement);
            }
        });

		function showMenu(thisRef) {
            var megamenuHeight = thisRef.find($(".megamenu")).outerHeight(true);
            var newOverlayHeightWithBuffer = megamenuHeight + 180;
            bodyOverlay.addClass("visible");
            menuOverlay.addClass("visible");
            menuOverlay.css("height", newOverlayHeightWithBuffer + "px");
            $("body").addClass("megamenu-open");
            thisRef.addClass("arrow");
            thisRef.find("> a").addClass("link-color");
            // Check if logo and menu is white and remove if so
            if(navigationContainer.hasClass("white")) {
                navigationContainer.removeClass("white");
                navigationContainer.find(".logo").removeClass("white");
            }
        }

		function hideMenu(thisRef) {
            bodyOverlay.removeClass("visible");
            menuOverlay.removeClass("visible");
            $("body").removeClass("megamenu-open");
            thisRef.find("> a").removeClass("link-color");
            thisRef.removeClass("arrow");
            // Check if logo and menu is white and add if so
            if ($("body").attr('data-page') === 'frontpage-2017') {
                if($("body").hasClass("slider-white")) {
                    navigationContainer.addClass("white");
                    navigationContainer.find(".logo").addClass("white");
                }
            } else {
                navigationContainer.addClass("white");
                navigationContainer.find(".logo").addClass("white");
            }
        }
	});

